import PageForgotPassword from "./PageForgotPassword.vue";
export default PageForgotPassword;
